import api from "!../../../../../../releases/96fe0828270ac3eeb45be3398068c5d43c71ff9d/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../releases/96fe0828270ac3eeb45be3398068c5d43c71ff9d/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[1]!../../../../../../releases/96fe0828270ac3eeb45be3398068c5d43c71ff9d/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[2]!../../../../../../releases/96fe0828270ac3eeb45be3398068c5d43c71ff9d/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[3]!./admin.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};